/**
 * NAD3-240 Live Orders Popup - JavaScript
 */

// Array of sample orders for NAD3-240
const orders = [
    { name: "Georgia", location: "FL", product: "NAD3 240 1 Bottle", time: "14 minutes ago" },
    { name: "Eric", location: "WA", product: "NAD3 240 1 Bottle", time: "29 minutes ago" },
    { name: "Judith", location: "OR", product: "NAD3 240 1 Bottle", time: "43 minutes ago" },
    { name: "Salvador", location: "CA", product: "NAD3 240 1 Bottle", time: "58 minutes ago" },
    { name: "Jo Ann", location: "WY", product: "NAD3 240 1 Bottle", time: "1 hour 13 minutes ago" },
    { name: "John", location: "MD", product: "NAD3 240 1 Bottle", time: "1 hour 28 minutes ago" },
    { name: "Carolina", location: "FL", product: "NAD3 240 4 Bottles", time: "1 hour 45 minutes ago" },
    { name: "Soledad", location: "FL", product: "NAD3 240 1 Bottle", time: "2 hours 1 minute ago" },
    { name: "Randi", location: "NJ", product: "NAD3 240 1 Bottle", time: "2 hours 18 minutes ago" },
    { name: "Deborah", location: "MN", product: "NAD3 240 1 Bottle", time: "2 hours 35 minutes ago" },
    { name: "Leo", location: "NY", product: "NAD3 240 2 Bottles", time: "16 minutes ago" },
    { name: "Dennis", location: "FL", product: "NAD3 240 1 Bottle", time: "30 minutes ago" },
    { name: "Gregory", location: "CA", product: "NAD3 240 1 Bottle", time: "45 minutes ago" },
    { name: "Gloria", location: "CA", product: "NAD3 240 1 Bottle", time: "1 hour 1 minute ago" },
    { name: "Blair", location: "CA", product: "NAD3 240 1 Bottle", time: "1 hour 17 minutes ago" },
    { name: "Juan", location: "IL", product: "NAD3 240 1 Bottle", time: "1 hour 34 minutes ago" },
    { name: "Linda", location: "OH", product: "NAD3 240 1 Bottle", time: "1 hour 51 minutes ago" },
    { name: "Blanca", location: "UT", product: "NAD3 240 2 Bottles", time: "2 hours 9 minutes ago" },
    { name: "James", location: "NV", product: "NAD3 240 1 Bottle", time: "2 hours 27 minutes ago" },
    { name: "Frank", location: "BC", product: "NAD3 240 1 Bottle", time: "2 hours 45 minutes ago" },
    { name: "Blanca", location: "OH", product: "NAD3 240 1 Bottle", time: "17 minutes ago" },
    { name: "Roger", location: "AZ", product: "NAD3 240 1 Bottle", time: "33 minutes ago" },
    { name: "D R", location: "AZ", product: "NAD3 240 1 Bottle", time: "48 minutes ago" },
    { name: "Elizabeth", location: "NY", product: "NAD3 240 1 Bottle", time: "1 hour 5 minutes ago" },
    { name: "Michael", location: "CA", product: "NAD3 240 1 Bottle", time: "1 hour 22 minutes ago" },
    { name: "Christina", location: "KY", product: "NAD3 240 1 Bottle", time: "1 hour 40 minutes ago" },
    { name: "Amanda", location: "FL", product: "NAD3 240 1 Bottle", time: "1 hour 59 minutes ago" },
    { name: "Irina", location: "FL", product: "NAD3 240 2 Bottles", time: "2 hours 19 minutes ago" },
    { name: "Paul", location: "OK", product: "NAD3 240 1 Bottle", time: "2 hours 39 minutes ago" },
    { name: "Luis", location: "TX", product: "NAD3 240 1 Bottle", time: "2 hours 58 minutes ago" }
];

// Display popup function
function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    
    popup.innerHTML = `
        <div class="popup-content">
            <div class="popup-image">
                <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/NAD3_240_Day_Supply_Zoom.png?v=1733437226" alt="Product Image">
                <span class="glow-dot"></span>
            </div>
            <div class="popup-text">
                <div class="popup-line">
                    <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
                </div>
                <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
                <div class="popup-line order-time">${randomOrder.time}</div>
                <div class="verified-buyer-badge">Verified Buyer</div>
            </div>
        </div>
    `;
    
    popup.style.display = 'block';

    setTimeout(() => {
        popup.classList.add('popup-hide');
    }, 6000);

    setTimeout(() => {
        popup.style.display = 'none';
        popup.classList.remove('popup-hide');
        setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
}

// Random time intervals between popups
function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
}

// Start the popup display
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
});
